const messages = require('./vi-VN/messages.json');

const extraMsg = {
  'Address Line 1 (Unit, Street)': 'Địa chỉ(Đường)',
  'Address Line 2 (Province)': 'Địa chỉ(Tỉnh)',
  'Address Line 3 (City)': 'Địa chỉ(Thành phố)',
  'Postal Code': 'Mã vùng bưu điện(Không bắt buộc)',
  'Vehicle Brand': 'Hãng xe',
  'Vehicle Model': 'Hiệu xe',
  'Vehicle Identification Type': 'Loại giấy tờ xe',
  'Vehicle Plate Number': 'Biển xe',
  'Full Name': 'Họ và tên',
  'Vehicle Chassis Number': 'Số khung(nhập cả dãy)',
  'Vehicle Engine Number': 'Số máy(nhập cả dãy)',
  'Vehicle Chassis & Engine Number': 'Số khung và số máy',
  'Personal Identification Type': 'Loại giấy tờ cá nhân',
  female: 'Nữ',
  male: 'Nam',
  Applicant: 'Đơn bảo hiểm',
  'Address Line 1 (City/Province)': 'Thành phố/Tỉnh',
  'Address Line 2 (District)': 'Quận/Huyện',
  'Address Line 3 (Ward)': 'Phường/Xã',
  'Date of birth': 'Ngày sinh',
  'ID / Passport Number': 'Số CMND/CCCD',
  'Additional Insured': 'Thông tin người được bảo hiểm bổ sung/kèm theo',
  'Insured People': 'Người được bảo hiểm',
  RelationShip: 'Quan hệ',
  Policy: 'Hợp đồng bảo hiểm',
  Self: 'Bản thân',
  'Wife/ Husband': 'Vợ/Chồng',
  'Child/ Adopted child': 'Con đẻ/nuôi hợp pháp',
  'Father/ Mother of your wife/ husband': 'Bố/Mẹ của vợ/chồng',
  'Brother/ Sister': 'Anh/Chị/Em ruột',
  'Father/ Mather': 'Bố/Mẹ đẻ',
  'Registration Date': 'Ngày đăng kí xe',
  'Seats Number': 'Số chỗ ngồi (Gồm tài xế)',
  'Manufacture Date': 'Ngày đăng kí xe',
  'Policy Owner Name': 'Tên chủ hợp đồng',
  'Policy Owner Phone Number': 'Số điện thoại chủ hợp đồng',
  'Vehicle Owner’s Name': 'Tên chủ xe',
  Model: 'Đời xe',
  'Vehicle Front': 'Phía trước',
  'Vehicle Rear': 'Phía sau',
  'Vehicle Left': 'Mặt trái',
  'Vehicle Right': 'Mặt phải',
  'Vehicle Identification Image': 'Ảnh giấy tờ xe',
  'Vehicle Registration Stamp + Car VIN Number': 'Tem đăng kí và số VIN',
  'Chassis Number/Engine Series Number': 'Số khung / Số máy',
  Family: 'Gia đình',
};

const finalMsg = {
  ...messages,
  ...extraMsg,
};

export default finalMsg;
